import { render, staticRenderFns } from "./AgregarPrecioModalComponent.vue?vue&type=template&id=3752ac46&"
import script from "./AgregarPrecioModalComponent.vue?vue&type=script&lang=js&"
export * from "./AgregarPrecioModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports